module.exports = __webpack_public_path__ + "media/Footprints/HomeImprovement-d1d3ec72.svg";